"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscription = exports.OfferType = exports.UnavailableReason = exports.ILineItemCustomFields = void 0;
var index_1 = require("./index");
var buildUpdateActions_1 = require("./lib/buildUpdateActions");
var helpers_1 = require("./utils/helpers");
var isDefined_1 = require("./utils/isDefined");
var money_1 = __importDefault(require("./utils/money"));
var prices_1 = require("./utils/prices");
var subscription_1 = require("./utils/subscription");
var debug_1 = __importDefault(require("debug"));
var flatMap_1 = __importDefault(require("lodash/flatMap"));
var pick_1 = __importDefault(require("lodash/pick"));
var debug = (0, debug_1.default)('nuts:ad');
var ILineItemBaseFields = {
    names: ['quantity', 'sku', 'addedAt'],
};
exports.ILineItemCustomFields = {
    names: [
        'active',
        'backupProduct',
        'backupQuantity',
        'backupVariantId',
        'cancellationReason',
        'cancellationReasonDetails',
        'cancelledAt',
        'committedPiecePrice',
        'createdByOrderSkuId',
        'discontinuedReplacedProduct',
        'discontinuedReplacedVariantId',
        'discontinuedReplacedQuantity',
        'distributionChannelKey',
        'errorDuringExecution',
        'expiresOn',
        'externalId',
        'interval',
        'lastEventEmitted',
        'lastEventEmittedAt',
        'lastOrderPiecePrice',
        'lastOrderPlacedAt',
        'lastPlaceOrderCall',
        'nextNextShipOn',
        'nextShipOn',
        'nextShipOnAtCancellation',
        'offerLocation',
        'offerType',
        'ogSubscriptionId',
        'ogUserId',
        'parentExternalId',
        'replacedSubscriptionId',
        'sendEmailOnCancellation',
        'sendEmailOnCreation',
        'shippingAddressId',
        'skipped',
    ],
};
var UnavailableReason;
(function (UnavailableReason) {
    UnavailableReason["ProductNotPublished"] = "ProductNotPublished";
    UnavailableReason["SkippedByCustomer"] = "SkippedByCustomer";
    UnavailableReason["VariantBackordered"] = "VariantBackordered";
    UnavailableReason["VariantHasNoPrice"] = "VariantHasNoPrice";
    UnavailableReason["VariantInactive"] = "VariantInactive";
    UnavailableReason["VariantIneligible"] = "VariantIneligible";
})(UnavailableReason = exports.UnavailableReason || (exports.UnavailableReason = {}));
var OfferType;
(function (OfferType) {
    OfferType["IURecurring"] = "IU Recurring";
    OfferType["IUUpsell"] = "IU Upsell";
    OfferType["OneClickIURecurring"] = "One Click-IU Recurring";
    OfferType["Standard"] = "Standard";
})(OfferType = exports.OfferType || (exports.OfferType = {}));
var PARENT_ONLY_UPDATE_FIELDS = [
    // It is not possible to backup a bundle and we don't want to set all children to the same product
    'backupProduct',
    'backupQuantity',
    'backupVariantId',
    // Piece price belongs to the parent, not the children
    'committedPiecePrice',
    // the replacement is related to each child, not the parent
    'discontinuedReplacedProduct',
    'discontinuedReplacedVariantId',
    'discontinuedReplacedQuantity',
    // externalId should be unique per subscription
    'externalId',
    // Piece price belongs to the parent, not the children
    'lastOrderPiecePrice',
    // Parent and children can't have the same subscription as origin
    'replacedSubscriptionId',
    // Parent and children can't have the same parentExternalId
    'parentExternalId',
    // There is no reason to update all children to the same SKU.
    // Cancelling the subscription in favor of a new one is preferable.
    'sku',
];
var Subscription = /** @class */ (function () {
    function Subscription(client, lineItem, shippingAddress, productInfo) {
        var _a, _b, _c, _d;
        this.client = client;
        this.lineItem = lineItem;
        if (!lineItem.custom || !lineItem.variant || !lineItem.variant.sku) {
            throw new Error('invalid line item');
        }
        this.id = lineItem.id;
        this.name = lineItem.name;
        this.quantity = lineItem.quantity;
        this.addedAt = lineItem.addedAt;
        this.deactivatedAt = lineItem.deactivatedAt;
        this.productId = lineItem.productId;
        this.variant = __assign(__assign({}, lineItem.variant), (0, helpers_1.pivotAttributeValues)(lineItem.variant.attributes).variant);
        this.images = (_a = productInfo === null || productInfo === void 0 ? void 0 : productInfo.images) !== null && _a !== void 0 ? _a : lineItem.variant.images;
        this.productKey = (_b = productInfo === null || productInfo === void 0 ? void 0 : productInfo.key) !== null && _b !== void 0 ? _b : '';
        this.productPath = productInfo === null || productInfo === void 0 ? void 0 : productInfo.productPath;
        this.shippingAddress = shippingAddress;
        this.sku = lineItem.variant.sku;
        this.variantName = this.variant.variantName;
        Object.assign(this, lineItem.custom.fields);
        if (this.skipped) {
            this.unavailableReason = UnavailableReason.SkippedByCustomer;
        }
        else if (!this.variant.autoDeliveryEligible) {
            this.unavailableReason = UnavailableReason.VariantIneligible;
        }
        else if (!this.variant.active) {
            this.unavailableReason = UnavailableReason.VariantInactive;
        }
        else if (this.variant.backordered) {
            this.unavailableReason = UnavailableReason.VariantBackordered;
        }
        else if (lineItem.deactivatedAt || !lineItem.published) {
            this.unavailableReason = UnavailableReason.ProductNotPublished;
        }
        var price = (_d = (_c = this.variant.prices) === null || _c === void 0 ? void 0 : _c.find(function (p) { return p.value.currencyCode === 'USD'; })) === null || _d === void 0 ? void 0 : _d.value;
        if (!price) {
            this.unavailableReason = UnavailableReason.VariantHasNoPrice;
        }
        var mainPrices = (0, prices_1.computePrices)({
            committedPiecePrice: this.committedPiecePrice,
            interval: this.interval,
            quantity: this.quantity,
            variant: this.variant,
        });
        this.currentPiecePrice = mainPrices.currentPiecePrice;
        this.piecePrice = mainPrices.piecePrice;
        this.discountedPiecePrice = mainPrices.discountedPiecePrice;
        this.extendedPrice = mainPrices.extendedPrice;
        this.extendedPiecePrice = this.extendedPrice;
        this.discountedExtendedPrice = mainPrices.discountedExtendedPrice;
        this.onSale = mainPrices.onSale;
        if (this.lastOrderPiecePrice) {
            // if it's within a few cents, consider it the same
            var diff = Math.abs(this.lastOrderPiecePrice.centAmount - this.piecePrice.centAmount);
            if (diff < 3) {
                this.lastOrderPiecePrice = undefined;
            }
        }
        this.displayBackupProduct = (0, subscription_1.buildBackupProductData)({
            backupProduct: this.backupProduct,
            backupQuantity: this.backupQuantity,
            backupVariantId: this.backupVariantId,
            interval: this.interval,
        });
        if (!this.displayBackupProduct) {
            this.backupProduct = undefined;
            this.backupQuantity = undefined;
            this.backupVariantId = undefined;
        }
        this.displayDiscontinuedReplacedProduct =
            (0, subscription_1.buildDiscontinuedReplacedProductData)({
                discontinuedReplacedProduct: this.discontinuedReplacedProduct,
                discontinuedReplacedVariantId: this.discontinuedReplacedVariantId,
                discontinuedReplacedQuantity: this.discontinuedReplacedQuantity,
            });
    }
    Subscription.calculateNextShipOn = function (_a) {
        var _b, _c;
        var addedAt = _a.addedAt, interval = _a.interval, lastOrderPlacedAt = _a.lastOrderPlacedAt, nextShipOn = _a.nextShipOn;
        if (!interval) {
            return undefined;
        }
        var fixTimestampIfDefined = function (dateTimeString) { var _a; return (_a = dateTimeString === null || dateTimeString === void 0 ? void 0 : dateTimeString.replace(/(\+\d\d)(\d\d)$/, '$1:$2')) !== null && _a !== void 0 ? _a : undefined; };
        var lastOn = Date.parse((_c = (_b = nextShipOn !== null && nextShipOn !== void 0 ? nextShipOn : fixTimestampIfDefined(lastOrderPlacedAt)) !== null && _b !== void 0 ? _b : fixTimestampIfDefined(addedAt)) !== null && _c !== void 0 ? _c : new Date().toISOString().substring(0, '0000-00-00'.length));
        var next = lastOn;
        while (next <= lastOn) {
            next += interval * 24 * 60 * 60 * 1000;
        }
        return new Date(next).toISOString().substring(0, '0000-00-00'.length);
    };
    Subscription.create = function (draft, client, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.retryConcurrentModification, retryConcurrentModification = _c === void 0 ? false : _c;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_d) {
                return [2 /*return*/, (0, index_1.retry)(function () { return __awaiter(_this, void 0, void 0, function () {
                        var nextShipOn;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            nextShipOn = (_a = draft.nextShipOn) !== null && _a !== void 0 ? _a : Subscription.calculateNextShipOn(draft);
                            return [2 /*return*/, Subscription.createRaw(__assign(__assign({}, draft), { active: (_b = draft.active) !== null && _b !== void 0 ? _b : true, committedPiecePrice: money_1.default.from(draft.committedPiecePrice), lastOrderPiecePrice: money_1.default.from(draft.lastOrderPiecePrice), nextShipOn: nextShipOn, nextNextShipOn: Subscription.calculateNextShipOn({
                                        interval: draft.interval,
                                        nextShipOn: nextShipOn,
                                    }), shippingAddressId: String(draft.shippingAddressId) }), client)];
                        });
                    }); }, {
                        onError: function (e) { return e.statusCode === 409 && retryConcurrentModification; },
                        reset: function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, client.getSubscriptions({
                                            force: true,
                                            preloadImagesAndPaths: false,
                                            preloadPaymentMethod: false,
                                            preloadShippingAddresses: false,
                                        })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); },
                    })];
            });
        });
    };
    Subscription.createRaw = function (draft, client) {
        return __awaiter(this, void 0, void 0, function () {
            var addedAt, quantity, sku, fields;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addedAt = draft.addedAt, quantity = draft.quantity, sku = draft.sku, fields = __rest(draft, ["addedAt", "quantity", "sku"]);
                        return [4 /*yield*/, client.addLineItem({
                                addedAt: addedAt,
                                quantity: quantity,
                                sku: sku,
                                custom: { type: { typeId: 'type', key: 'autoDeliveryLineItem' }, fields: fields },
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Subscription.validate = function (subscription, setOrNot, errorPrefix) {
        var messages = (0, flatMap_1.default)(setOrNot, function (expected, field) {
            if (expected !== (subscription[field] !== undefined)) {
                return ["".concat(field, " must ").concat(expected ? '' : 'not ', "be set")];
            }
            return [];
        });
        if (messages.length) {
            throw new Error("".concat(errorPrefix).concat(messages.join(', ')));
        }
    };
    Subscription.prototype.setChildren = function (children) {
        this.children = children;
    };
    Subscription.prototype.calculatePricesWithChildren = function () {
        var _a;
        var entries = __spreadArray([this], ((_a = this.children) !== null && _a !== void 0 ? _a : []), true).filter(function (s) {
            return !s.unavailableReason ||
                s.unavailableReason === UnavailableReason.SkippedByCustomer ||
                s.displayBackupProduct;
        })
            .map(function (entry) { return (0, subscription_1.subscriptionOrBackup)(entry); });
        this.currentPiecePrice = money_1.default.sumBy(entries, function (s) { return s.currentPiecePrice; });
        this.discountedExtendedPrice = money_1.default.sumBy(entries, function (s) { return s.discountedExtendedPrice; });
        this.discountedPiecePrice = money_1.default.sumBy(entries, function (s) { return s.discountedPiecePrice; });
        this.extendedPrice = money_1.default.sumBy(entries, function (s) { return s.extendedPrice; });
        this.piecePrice = money_1.default.sumBy(entries, function (s) { return s.piecePrice; });
    };
    Subscription.prototype.product = function (queryArgs) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.client.api
                            .products()
                            .withId({ ID: this.lineItem.productId })
                            .get({ queryArgs: queryArgs })
                            .execute()];
                    case 1: return [2 /*return*/, (_a.sent()).body];
                }
            });
        });
    };
    /** @deprecated since 0.3.8; use .shippingAddress property */
    Subscription.prototype.getShippingAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.shippingAddress];
            });
        });
    };
    Subscription.prototype.cancel = function (cancellationReason, cancellationReasonDetails, sendEmailOnCancellation) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.update(this.buildCancelFieldChanges({
                            cancellationReason: cancellationReason,
                            cancellationReasonDetails: cancellationReasonDetails,
                            sendEmailOnCancellation: sendEmailOnCancellation,
                        }), { retryConcurrentModification: true })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Subscription.prototype.getAlternateVariants = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.client.getAlternateVariants(this.variant)];
            });
        });
    };
    Subscription.prototype.normalize = function (draft) {
        var committedPiecePrice = draft.committedPiecePrice, lastOrderPiecePrice = draft.lastOrderPiecePrice, shippingAddressId = draft.shippingAddressId, quantity = draft.quantity, other = __rest(draft, ["committedPiecePrice", "lastOrderPiecePrice", "shippingAddressId", "quantity"]);
        var norm = other;
        if ('committedPiecePrice' in draft) {
            norm.committedPiecePrice = money_1.default.from(committedPiecePrice);
        }
        if ('lastOrderPiecePrice' in draft) {
            norm.lastOrderPiecePrice = money_1.default.from(lastOrderPiecePrice);
        }
        if (shippingAddressId) {
            norm.shippingAddressId = String(shippingAddressId);
        }
        if ('quantity' in draft) {
            if (this.preferBackup) {
                norm.backupQuantity = quantity;
            }
            if (!this.preferBackup || this.parentExternalId) {
                norm.quantity = quantity;
                norm.discontinuedReplacedProduct = undefined;
                norm.discontinuedReplacedVariantId = undefined;
                norm.discontinuedReplacedQuantity = undefined;
            }
        }
        return norm;
    };
    Subscription.prototype.validateChanges = function (changes) {
        var after = __assign(__assign({}, this), changes);
        if (after.active) {
            Subscription.validate(after, {
                cancelledAt: false,
                cancellationReason: false,
                nextShipOn: true,
            }, 'when subscription is active, ');
        }
        else {
            Subscription.validate(after, {
                cancelledAt: true,
                nextShipOn: false,
            }, 'when subscription is inactive, ');
        }
    };
    /**
     * Updates the subscription with the given changes.
     *
     * If the subscription has children, the changes are applied to the children as well, unless the changes contains fields that are not allowed to be updated for children with defined values. See {@link PARENT_ONLY_UPDATE_FIELDS}.
     */
    Subscription.prototype.update = function (changes, _a) {
        var _b;
        var _c = _a === void 0 ? {} : _a, _d = _c.replaceDiscontinuedProduct, replaceDiscontinuedProduct = _d === void 0 ? false : _d, _e = _c.retryConcurrentModification, retryConcurrentModification = _e === void 0 ? false : _e;
        return __awaiter(this, void 0, void 0, function () {
            var normalizedChanges, addLineItemActions, latestList, currentListIsFull, newLineItemFields, cancelFieldChanges, subscriptionsToUpdate, shouldUpdateChildren, subscriptionsToUpdateIds;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        normalizedChanges = this.normalize(changes);
                        addLineItemActions = [];
                        if (!(changes.sku && changes.sku !== this.sku)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.client.getLatestShoppingList()];
                    case 1:
                        latestList = _f.sent();
                        return [4 /*yield*/, this.client.checkIfShoppingListIsFull(latestList)];
                    case 2:
                        currentListIsFull = _f.sent();
                        newLineItemFields = this.buildNewLineItemFields(__assign(__assign(__assign({}, normalizedChanges), (replaceDiscontinuedProduct
                            ? {
                                discontinuedReplacedProduct: {
                                    typeId: 'product',
                                    id: this.productId,
                                },
                                discontinuedReplacedVariantId: this.variant.id,
                                discontinuedReplacedQuantity: this.quantity,
                            }
                            : {})), { replacedSubscriptionId: this.id }));
                        if (!currentListIsFull) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.client.createAndSetLists(newLineItemFields)];
                    case 3:
                        _f.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        addLineItemActions.push(__assign(__assign({}, newLineItemFields), { action: 'addLineItem' }));
                        _f.label = 5;
                    case 5:
                        cancelFieldChanges = this.buildCancelFieldChanges({
                            cancellationReason: { en: "Changing sku to ".concat(changes.sku) },
                            // Detach the subscription from the bundle
                            extraFields: { parentExternalId: undefined },
                            sendEmailOnCancellation: changes.sendEmailOnCancellation,
                        });
                        // update normalizedChanges to include canceled fields
                        normalizedChanges = this.normalize(cancelFieldChanges);
                        _f.label = 6;
                    case 6:
                        subscriptionsToUpdate = [this];
                        if ((_b = this.children) === null || _b === void 0 ? void 0 : _b.length) {
                            shouldUpdateChildren = !PARENT_ONLY_UPDATE_FIELDS.some(function (field) {
                                return field in normalizedChanges && (0, isDefined_1.isDefined)(normalizedChanges[field]);
                            });
                            if (shouldUpdateChildren) {
                                subscriptionsToUpdate.push.apply(subscriptionsToUpdate, this.children);
                            }
                            else {
                                debug('Skipping children while updating subscription', {
                                    subscriptionId: this.id,
                                    changes: normalizedChanges,
                                });
                            }
                        }
                        subscriptionsToUpdateIds = subscriptionsToUpdate.map(function (s) { return s.id; });
                        return [2 /*return*/, (0, index_1.retry)(function () { return __awaiter(_this, void 0, void 0, function () {
                                var updateActions, lineItemUpdateActionsByList, listUpdates, _a, _b;
                                var _this = this;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            updateActions = (0, flatMap_1.default)(subscriptionsToUpdate, function (subscription) {
                                                var normalized = subscription.id === _this.id
                                                    ? normalizedChanges
                                                    : subscription.normalize(changes);
                                                subscription.validateChanges(normalized);
                                                return (0, buildUpdateActions_1.buildUpdateActions)(normalized, subscription);
                                            });
                                            return [4 /*yield*/, this.client.buildLineItemUpdateActionsByList(updateActions)];
                                        case 1:
                                            lineItemUpdateActionsByList = _c.sent();
                                            if (!lineItemUpdateActionsByList) {
                                                debug('No line item update actions', {
                                                    lineItemUpdateActionsByList: lineItemUpdateActionsByList,
                                                });
                                                return [2 /*return*/];
                                            }
                                            listUpdates = lineItemUpdateActionsByList.map(function (updateAction, index) {
                                                var list = updateAction.list, _a = updateAction.actions, actions = _a === void 0 ? [] : _a;
                                                var allActions = __spreadArray([], actions, true);
                                                if (index === 0) {
                                                    // only add line item to first list (latest list)
                                                    allActions.push.apply(allActions, addLineItemActions);
                                                }
                                                return _this.client.updateList(list, allActions);
                                            });
                                            _b = (_a = this.client).setLists;
                                            return [4 /*yield*/, Promise.all(listUpdates)];
                                        case 2:
                                            _b.apply(_a, [_c.sent()]);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, {
                                onError: function (e) {
                                    return (e.statusCode === 409 && retryConcurrentModification) ||
                                        [502, 503].includes(e.statusCode);
                                },
                                reset: function () { return __awaiter(_this, void 0, void 0, function () {
                                    var missingSubscriptions;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, this.client.getSubscriptions({
                                                    force: true,
                                                    includeInactive: true,
                                                    preloadImagesAndPaths: false,
                                                    preloadPaymentMethod: false,
                                                    preloadShippingAddresses: false,
                                                })];
                                            case 1:
                                                subscriptionsToUpdate = (_a.sent()).filter(function (s) { return subscriptionsToUpdateIds.includes(s.id); });
                                                if (subscriptionsToUpdate.length !== subscriptionsToUpdateIds.length) {
                                                    missingSubscriptions = subscriptionsToUpdateIds.filter(function (id) { return !subscriptionsToUpdate.some(function (s) { return s.id === id; }); });
                                                    throw new Error("Couldn't find targeted subscriptions: ".concat(missingSubscriptions.join(', ')));
                                                }
                                                return [2 /*return*/];
                                        }
                                    });
                                }); },
                            })];
                }
            });
        });
    };
    Subscription.prototype.resume = function (subscriptionChanges) {
        var _a, _b, _c;
        if (subscriptionChanges === void 0) { subscriptionChanges = {}; }
        var interval = (_a = subscriptionChanges.interval) !== null && _a !== void 0 ? _a : this.interval;
        var shippingAddressId = (_b = subscriptionChanges.shippingAddressId) !== null && _b !== void 0 ? _b : this.shippingAddressId;
        var nextShipOnCalculated = (_c = subscriptionChanges.nextShipOn) !== null && _c !== void 0 ? _c : Subscription.calculateNextShipOn({ interval: this.interval });
        var nextNextShipOnCalculated = Subscription.calculateNextShipOn({
            interval: this.interval,
            nextShipOn: nextShipOnCalculated,
        });
        return this.update({
            active: true,
            cancellationReason: undefined,
            cancellationReasonDetails: undefined,
            cancelledAt: undefined,
            errorDuringExecution: undefined,
            interval: interval,
            lastOrderPiecePrice: undefined,
            lastOrderPlacedAt: undefined,
            lastPlaceOrderCall: undefined,
            nextNextShipOn: nextNextShipOnCalculated,
            nextShipOn: nextShipOnCalculated,
            nextShipOnAtCancellation: undefined,
            sendEmailOnCancellation: undefined,
            sendEmailOnCreation: undefined,
            shippingAddressId: shippingAddressId,
            skipped: false,
        }, { retryConcurrentModification: true });
    };
    Subscription.prototype.skip = function () {
        return this.update({
            skipped: true,
            discontinuedReplacedProduct: undefined,
            discontinuedReplacedVariantId: undefined,
            discontinuedReplacedQuantity: undefined,
        }, { retryConcurrentModification: true });
    };
    Subscription.prototype.unskip = function () {
        return this.update({
            skipped: false,
            discontinuedReplacedProduct: undefined,
            discontinuedReplacedVariantId: undefined,
            discontinuedReplacedQuantity: undefined,
        }, { retryConcurrentModification: true });
    };
    Subscription.prototype.setBackupSku = function (sku) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var response, product, current, variant, variantAttributes, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.client.api
                                .products()
                                .get({
                                queryArgs: {
                                    where: "masterData(current(masterVariant(sku = \"".concat(sku, "\") or variants(sku = \"").concat(sku, "\") ))"),
                                    expand: 'masterData.current.variants[*].prices[*].channel',
                                },
                            })
                                .execute()];
                    case 1:
                        response = _c.sent();
                        product = response.body.results[0];
                        current = product === null || product === void 0 ? void 0 : product.masterData.current;
                        variant = __spreadArray([
                            current === null || current === void 0 ? void 0 : current.masterVariant
                        ], ((_a = current === null || current === void 0 ? void 0 : current.variants) !== null && _a !== void 0 ? _a : []), true).find(function (v) { return (v === null || v === void 0 ? void 0 : v.sku) === sku; });
                        if (!variant) {
                            throw new Error("Variant with SKU ".concat(sku, " not found"));
                        }
                        variantAttributes = (0, helpers_1.pivotAttributeValues)(variant.attributes || []).variant;
                        if (!variantAttributes.active) {
                            throw new Error("Variant with SKU ".concat(sku, " is inactive"));
                        }
                        if (variantAttributes.backordered) {
                            throw new Error("Variant with SKU ".concat(sku, " is backordered"));
                        }
                        return [2 /*return*/, this.update({
                                backupProduct: {
                                    typeId: 'product',
                                    id: product.id,
                                },
                                backupQuantity: (_b = this.backupQuantity) !== null && _b !== void 0 ? _b : this.quantity,
                                backupVariantId: variant.id,
                                discontinuedReplacedProduct: undefined,
                                discontinuedReplacedQuantity: undefined,
                                discontinuedReplacedVariantId: undefined,
                            }, {
                                retryConcurrentModification: true,
                            })];
                    case 2:
                        error_1 = _c.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Subscription.prototype, "description", {
        get: function () {
            var _a;
            if ((_a = this.children) === null || _a === void 0 ? void 0 : _a.length) {
                var children = this.children.map(function (child) {
                    return (0, subscription_1.subscriptionOrBackup)(child);
                });
                var quantityByName = children.reduce(function (acc, sub) {
                    var productName = sub.name.en;
                    acc[productName] = (acc[productName] || 0) + sub.quantity;
                    return acc;
                }, {});
                return Object.entries(quantityByName)
                    .map(function (_a) {
                    var productName = _a[0], totalQuantity = _a[1];
                    return "".concat(totalQuantity, "x ").concat(productName);
                })
                    .join(', ');
            }
            var subscription = (0, subscription_1.subscriptionOrBackup)(this);
            return "".concat(subscription.quantity, "x ").concat(subscription.name.en);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Subscription.prototype, "preferBackup", {
        get: function () {
            return this.variant.backordered && !!this.displayBackupProduct;
        },
        enumerable: false,
        configurable: true
    });
    Subscription.prototype.buildCancelFieldChanges = function (options) {
        var _a;
        return __assign({ active: false, backupProduct: undefined, backupQuantity: undefined, backupVariantId: undefined, cancellationReason: options.cancellationReason, cancellationReasonDetails: options.cancellationReasonDetails, cancelledAt: new Date().toISOString(), discontinuedReplacedProduct: undefined, discontinuedReplacedQuantity: undefined, discontinuedReplacedVariantId: undefined, nextNextShipOn: undefined, nextShipOn: undefined, nextShipOnAtCancellation: this.nextShipOn, sendEmailOnCancellation: (_a = options.sendEmailOnCancellation) !== null && _a !== void 0 ? _a : true }, options.extraFields);
    };
    Subscription.prototype.buildNewLineItemFields = function (extraFields) {
        if (extraFields === void 0) { extraFields = {}; }
        var thisFields = (0, pick_1.default)(this, ILineItemBaseFields.names, exports.ILineItemCustomFields.names);
        var draft = __assign(__assign(__assign({}, thisFields), { addedAt: undefined, committedPiecePrice: undefined, errorDuringExecution: undefined, lastOrderPiecePrice: undefined, lastEventEmitted: undefined, lastEventEmittedAt: undefined, lastPlaceOrderCall: undefined, backupProduct: undefined, backupQuantity: undefined, backupVariantId: undefined, discontinuedReplacedProduct: undefined, discontinuedReplacedQuantity: undefined, discontinuedReplacedVariantId: undefined, sendEmailOnCreation: undefined, sendEmailOnCancellation: undefined, offerType: OfferType.IURecurring }), extraFields);
        var addedAt = draft.addedAt, quantity = draft.quantity, sku = draft.sku, fields = __rest(draft, ["addedAt", "quantity", "sku"]);
        return {
            addedAt: addedAt,
            quantity: quantity,
            sku: sku,
            custom: {
                type: { typeId: 'type', key: 'autoDeliveryLineItem' },
                fields: fields,
            },
        };
    };
    return Subscription;
}());
exports.Subscription = Subscription;
//# sourceMappingURL=Subscription.js.map